import { render } from "./ProductDetail.vue?vue&type=template&id=59c0ce1d"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__

/* vue-cli-plugin-import-components */

import BasicContainer from "@/components/BasicContainer.vue";
import BasicSpinner from "@/components/BasicSpinner.vue";
import Button from "@/components/Button.vue";
import ButtonDropdown from "@/components/ButtonDropdown.vue";
import FormLabel from "@/components/forms/FormLabel.vue";
import InlineSearchSelect from "@/components/InlineSearchSelect.vue";
import MainCol from "@/components/MainCol.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import PageFooter from "@/components/PageFooter.vue";
import PageGrid from "@/components/PageGrid.vue";
import ProductIngredients from "@/components/neue/ProductIngredients.vue";
import SaveBar from "@/components/SaveBar.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
import SideCol from "@/components/SideCol.vue";
import SimpleEmptyState from "@/components/SimpleEmptyState.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { BasicContainer, BasicSpinner, Button, ButtonDropdown, FormLabel, InlineSearchSelect, MainCol, NeueButton, PageFooter, PageGrid, ProductIngredients, SaveBar, SecondaryNav, SecondaryTop, SideCol, SimpleEmptyState, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicContainer, BasicSpinner, Button, ButtonDropdown, FormLabel, InlineSearchSelect, MainCol, NeueButton, PageFooter, PageGrid, ProductIngredients, SaveBar, SecondaryNav, SecondaryTop, SideCol, SimpleEmptyState, TheModal }, script.__o.components);}